<div mat-dialog-title>Gradebook Preferences</div>

<mat-dialog-content>
  <div>A problem was encountered and your preferences regarding which columns to show have been reset.To show additional
    columns, <a class="link" (click)="gradebookPreferencesClick()">change your preferences for Columns in Scores
      Grid.</a>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="flex-footer-right">
    <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()" style="float:right"></tyl-button>
  </div>
</mat-dialog-actions>